import { Avatar, Col, Image, Row, Tag } from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import styled from 'styled-components'
import avatarImg from '../../../assets/images/avatar.png'
import { translate } from '../../../languages'
import { UserTypeEnum } from '../../../models'
import { RootState } from '../../../stores'

const StyledContainer = styled.div`
  display: flex;
  width: 100%;
  height: 90%;
  padding: 50px 10%;
`

const StyledAvatarDesktop = styled.div`
  width: 20%;
  text-align: center;
`

const StyledNameDesktop = styled.div`
  margin-top: 20px;
  width: 100%;
  font-weight: bold;
  font-size: 1.3rem;
  display: inline-block;
`

const StyledInfor = styled.div`
  border-radius: 10px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -3px inset,
    rgba(0, 0, 0, 0.3) 0px 2px 36px -18px inset;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
`

const StyledInforRow = styled.div`
  width: 100%;
  margin-bottom: 10px;
  font-size: 1.1rem;
`

const StyledInforLabel = styled.span`
  font-weight: bold;
  margin-right: 10px;
`

const StyledRow = styled(Row)`
  margin-bottom: 20px;
`

export const ProfilePage: React.FC = () => {
  const { profile } = useSelector((state: RootState) => state.auth)
  const { language } = useSelector((state: RootState) => state.language)
  const isSmallScreen = useMediaQuery({ maxWidth: '800px' })
  return (
    profile && (
      <StyledContainer>
        {!isSmallScreen && (
          <StyledAvatarDesktop>
            <Avatar
              alt={profile?.name}
              size={{ md: 150, lg: 180, xl: 190, xxl: 200 }}
              src={<Image height="100%" src={avatarImg} />}
            />
            <StyledNameDesktop>{profile.name}</StyledNameDesktop>
          </StyledAvatarDesktop>
        )}
        <StyledInfor>
          <StyledRow gutter={24}>
            <Col span={12}>
              <StyledInforRow>
                <StyledInforLabel>
                  {translate('user.name', language)}:
                </StyledInforLabel>
                {profile.name}
              </StyledInforRow>
            </Col>
            <Col span={12}>
              <StyledInforRow>
                <StyledInforLabel>
                  {translate('user.username', language)}:
                </StyledInforLabel>
                {profile.username}
              </StyledInforRow>
            </Col>
          </StyledRow>
          <StyledRow gutter={24}>
            <Col span={12}>
              <StyledInforRow>
                <StyledInforLabel>
                  {translate('common.gender', language)}:
                </StyledInforLabel>
                {translate(
                  `common.gender.${profile.gender ? 'male' : 'female'}`,
                  language
                )}
              </StyledInforRow>
            </Col>
            <Col span={12}>
              <StyledInforRow>
                <StyledInforLabel>
                  {translate('common.phone', language)}:
                </StyledInforLabel>
                {profile.phone}
              </StyledInforRow>
            </Col>
          </StyledRow>
          <StyledRow gutter={24}>
            <Col span={12}>
              <StyledInforRow>
                <StyledInforLabel>
                  {translate('user.address', language)}:
                </StyledInforLabel>
                {profile.address}
              </StyledInforRow>
            </Col>
            <Col span={12}>
              <StyledInforRow>
                <StyledInforLabel>
                  {translate('common.identityCardNumber', language)}:
                </StyledInforLabel>
                {profile.identityCardNumber}
              </StyledInforRow>
            </Col>
          </StyledRow>
          <StyledRow gutter={24}>
            <Col span={12}>
              <StyledInforRow>
                <StyledInforLabel>
                  {translate('common.dateOfBirth', language)}:
                </StyledInforLabel>
                {new Date(profile.dateOfBirth).toLocaleDateString()}
              </StyledInforRow>
            </Col>
            <Col span={12}>
              <StyledInforRow>
                <StyledInforLabel>
                  {translate('user.email', language)}:
                </StyledInforLabel>
                {profile.email}
              </StyledInforRow>
            </Col>
          </StyledRow>
          <StyledInforRow>
            <StyledInforLabel>
              {translate('user.userType', language)}:
            </StyledInforLabel>
            <Tag
              style={{ fontSize: '1.2rem' }}
              color={
                profile.userType.type === UserTypeEnum.ADMIN
                  ? 'green'
                  : profile.userType.type === UserTypeEnum.CUSTOMER
                  ? 'blue'
                  : 'red'
              }
              key={profile.userType.type}
            >
              {translate(
                `user.userType.${profile.userType.type.toLowerCase()}`,
                language
              )}
            </Tag>
          </StyledInforRow>
        </StyledInfor>
      </StyledContainer>
    )
  )
}
